<template>
  <div></div>
</template>

<script>
export default {
  name: 'Auth',
  created() {
    this.$store.dispatch('auth/init');
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Auth/components/Main.vue